import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { AuthConstants, AuthService } from '../services/auth.service';
import { Observable, catchError, of, switchMap, tap } from 'rxjs';
import { ApplicationError } from '../models/application-error';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.get('skip')) {
      return next.handle(req);
    }
 
    return this.authService.accessToken()
      .pipe(
        switchMap(accessToken => {
          const cloned = req.clone({
            headers: req.headers.set("Authorization",
              "Bearer " + accessToken)
          });
          return next.handle(cloned);
        }),
        catchError((err) => {
          let httpError = err as HttpErrorResponse;
          if (httpError.status == 401) {
            return this.authService.refreshToken()
              .pipe(
                switchMap((authResult: any) => {
                  const cloned = req.clone({
                    headers: req.headers.set("Authorization",
                      "Bearer " + authResult.accessToken)
                  });
                  return next.handle(cloned);
                }),
                catchError(err => {
                  //this.authService.logout();
                  return of(null);
                }));
          }
          err.request = req;
          throw err;
        }));
  }
}
